import {
  GET_ALL_STAFF_LIST_REQUEST,
  GET_ALL_STAFF_LIST_SUCCESS,
  GET_ALL_STAFF_LIST_FAILURE,
  GET_USER_ACCESS_LIST_REQUEST,
  GET_USER_ACCESS_LIST_SUCCESS,
  GET_USER_ACCESS_LIST_FAILURE,
  UPDATE_USER_ACCESS_REQUEST,
  UPDATE_USER_ACCESS_SUCCESS,
  UPDATE_USER_ACCESS_FAILURE,
  GET_DEFAULT_ACCESS_REQUEST,
  GET_DEFAULT_ACCESS_SUCCESS,
  GET_DEFAULT_ACCESS_FAILURE,
} from "../../../Utils/Constant";

export const getStaffListRequest = (payload) => {
  return {
    type: GET_ALL_STAFF_LIST_REQUEST,
    payload: payload,
  };
};

export const getStaffListSuccess = (data) => {
  return {
    type: GET_ALL_STAFF_LIST_SUCCESS,
    payload: data,
  };
};

export const getStaffListFailure = (error) => {
  return {
    type: GET_ALL_STAFF_LIST_FAILURE,
    payload: error,
  };
};

// Single User Acccess Get & Update

export const getUserAccessListRequest = (payload) => {
  return {
    type: GET_USER_ACCESS_LIST_REQUEST,
    payload: payload,
  };
};

export const getUserAccessListSuccess = (data) => {
  return {
    type: GET_USER_ACCESS_LIST_SUCCESS,
    payload: data,
  };
};

export const getUserAccessListFailure = (error) => {
  return {
    type: GET_USER_ACCESS_LIST_FAILURE,
    payload: error,
  };
};

export const updateUserAccessRequest = (payload) => {
  return {
    type: UPDATE_USER_ACCESS_REQUEST,
    payload: payload,
  };
};

export const updateUserAccessSuccess = (data) => {
  return {
    type: UPDATE_USER_ACCESS_SUCCESS,
    payload: data,
  };
};

export const updateUserAccessFailure = (error) => {
  return {
    type: UPDATE_USER_ACCESS_FAILURE,
    payload: error,
  };

};

export const getDefaultAccessRequest = (payload) => {
  return {
    type: GET_DEFAULT_ACCESS_REQUEST,
    payload: payload,
  };
};

export const getDefaultAccessSuccess = (data) => {
  return {
    type: GET_DEFAULT_ACCESS_SUCCESS,
    payload: data,
  };
};

export const getDefaultAccessFailure = (error) => {
  return {
    type: GET_DEFAULT_ACCESS_FAILURE,
    payload: error,
  };
}